import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  DirectionSettingsModalContainer, type DirectionSettingsModalContainerProps,
} from './directionsSettings.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    DirectionSettings: DirectionSettingsModalContainerProps;
  }
}
modalRenderer.register('DirectionSettings', DirectionSettingsModalContainer);
